<template>
    <div>
        <v-card class="pa-5 margin-bottom">
            <v-row class="mx-2 mt-0 pt-0">
                <v-col cols="12" class="mt-0 pt-0">
                    <h1>Fields report</h1>
                </v-col>
            </v-row>
            <v-row class="mx-2 mt-0 pt-0">
                <v-col cols="12" class="text-center mt-0 pt-0">
                    <v-btn class="mt-4 generate-btn-margin" small color="success"
                           @click="handleGenerateClick">Generate current data
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>

        <!-- LIST part -->
        <v-card>
            <v-flex style="overflow: auto">
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :items-per-page="10"
                    :footer-props="{
                      'items-per-page-options': [5, 10, 20]
                    }"
                    item-key="id"
                    :options.sync="options"
                    :loading="loading"
                    loading-text="Loading fields"
                    :page="fieldsTableOptions && fieldsTableOptions.page ? fieldsTableOptions.page : 1"
                    :server-items-length="itemsCount"
                    class="elevation-1 data-analysis-table"
                >
                    <template v-slot:item="{ item }">
                        <tr
                            :key="`da_row_${item.id}`"
                        >
                            <td class="text-center">{{ item.id ? item.id : '-' }}</td>
                            <td class="text-center">{{ item.created_at ? item.created_at : '-' }}</td>
                            <td class="text-center">
                                {{ item.count ? item.count : '-' }}
                            </td>
                            <td class="text-center">
                                <v-chip
                                    :color="item.status === 'finished' ? 'success' : item.status === 'error' ? 'error' : 'grey lighten-2'">
                                    {{ item.status | cleanString }}
                                </v-chip>
                            </td>
                            <td class="text-center">
                                <v-icon v-if="item.status === 'finished'" @click="handleDownloadCsvFile(item.id)">
                                    mdi-download
                                </v-icon>
                                <v-icon v-else @click="handleRefresh()">
                                    mdi-refresh
                                </v-icon>
                            </td>
                        </tr>

                    </template>
                </v-data-table>
            </v-flex>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'FieldsList',
    data() {
        return {
            options: {},
            loading: false,

            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'Created at',
                    align: 'center',
                    sortable: false,
                    value: 'created_at',
                },
                {
                    text: 'Fields count',
                    align: 'center',
                    sortable: false,
                    value: 'count',
                },
                {
                    text: 'Status',
                    align: 'center',
                    sortable: false,
                    value: 'status',
                },
                {
                    text: 'Download',
                    align: 'center',
                    sortable: false,
                    value: 'download',
                },
            ],
        };
    },
    async mounted() {
        this.loading = true;
        await this.getFieldsData();
        this.loading = false;
    },
    computed: {
        ...mapState('report', ['fieldsTableOptions', 'fields', 'fieldsCount']),
        items() {
            return this.fields || [];
        },
        itemsCount() {
            return this.fieldsCount || 0;
        },
    },
    watch: {
        options(val) {
            this.setFieldsTableOptions(val);
        },
    },
    components: {},
    methods: {
        ...mapActions('report', ['generateCsvFile', 'downloadCsvFile', 'getFieldsData']),
        ...mapMutations('report', ['setFieldsTableOptions']),

        async handleGenerateClick() {
            await this.generateCsvFile({type: 'fields'});
            await this.getFieldsData();
        },

        async handleDownloadCsvFile(itemId) {
            const response = await this.downloadCsvFile(itemId);
            if (!response) {
                return;
            }
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${itemId}.csv`);
            document.body.appendChild(link);
            link.click();
        },

        async handleRefresh() {
            await this.getFieldsData();
        },
    },
};
</script>

<style scoped>

</style>